<div class="ai-summary-container" *ngIf="_syllabusData">
  <div class="header-banner">
    <div class="header-content">
      <mat-icon (click)="goBackToResources()" class="back text-start">arrow_back</mat-icon>
      <h4><span>{{ _syllabusData.course_title || "--" }}</span> Course </h4>
    </div>
    <p class="sub-text">
        A structured learning plan with clear objectives, key topics & resources.
    </p>
  </div>
  <div class="course-box">
    <div class="course-header">
      <div class="left">
        <h2 class="course-title">
          {{ _syllabusData.course_title }}
        </h2>
        <div class="code">
          <strong>Course Code : {{ _syllabusData.course_code || "--" }}</strong>
        </div>
        <div class="meta-tags">
          <span class="tag">
            <i class="bi bi-journal-bookmark-fill"></i> Units
            {{ _syllabusData.total_units_count || "--" }}
          </span>
          <span class="tag">
            <i class="bi bi-clock"></i>
            {{ _syllabusData.course_duration || "--" }} hours      
          </span>
        </div>
      </div>
    </div>

    <div class="main-container gap-2">
      <div class="course-section">
		<div class="justify-content-between d-flex">
        <h3 class="section-title">Course Structure</h3>
    </div>
<div 
         class="course-block-wrapper">
        <div class="course-block mb-3" *ngFor="let unit of _syllabusData.units; let i = index">
          <div class="block-header">
      <div class="drag-handle">
            <img src="assets/images/ai-toggle.svg" alt="Unit Icon" class="unit-icon mb-4" />
</div>
            <h4 class="unit-title">
              Unit {{ unit.order || "--" }}:  <span [innerHtml]="unit.unit_title || '--'"></span>
            <h6 class="hour mt-2">
				 <i class="bi bi-clock"></i> Total Duration : {{unit.unit_hours}} hours </h6>
            </h4>
          </div>
          <mat-accordion multi class="block-content outer-accordion">
            <mat-expansion-panel class="topic" *ngFor="let topic of unit.topics">
				<mat-expansion-panel-header>
					 <div class="d-flex justify-content-between align-items-start w-100">
					<div class="d-flex">
						<div  class="drag-handle m-0">
				<img src="assets/images/drag.png" class="me-3 topic-icon" alt="drag-icon">
				</div>
			<span [innerHtml]="topic.topic_title || '--'" class="title-wrapper"></span>
              </div>
		</div>
		</mat-expansion-panel-header>
		 <div class="px-x">
			    <p class="topic-description text-muted mb-3"> {{topic.description}}</p>
			<div class="subtopic-card" *ngFor="let sub of topic.subtopics">
				<div class="subtopic-header">
					<span class="dot"></span>
                 <h6><span [innerHtml]="sub.subtopic_title || '--'"></span></h6>
				</div>
				 <p class="description">{{sub.description || 'N/A'}}</p>
				   <ng-container *ngIf="sub.reference_links?.length">
						<div class="reference">
				  <label>References Links: </label>
				  <ul>
					 <li *ngFor="let link of sub.reference_links">
						<a [href]="link" target="_blank">{{link}} </a>
					</li>
				  </ul>
				  </div>
				   </ng-container> 
			        </div>
			</div>
            </mat-expansion-panel>
          </mat-accordion>
</div>
</div>

        <div class="course-card">
          <div class="card-header">
            <div class="header-left">
              <img src="assets/images/courseObject.png" alt="Course Icon" class="unit-icon" />
              <h4>Course Objective</h4>
            </div>
          </div>
          <ul class="objective-list">
            <li *ngFor="let objective of _syllabusData?.course_objectives">
              {{ objective || "--" }}
            </li>
          </ul>
        </div>

        <div class="course-card">
          <div class="card-header">
            <div class="header-left">
              <img src="assets/images/courseOutcome.png" alt="Course Icon" class="unit-icon" />
              <h4>Course Outcome</h4>
            </div>
          </div>
          <ul class="objective-list">
            <li *ngFor="let course_name of _syllabusData.course_outcomes">
              {{ course_name || "--" }}
            </li>
          </ul>
        </div>

        <div class="course-card">
          <div class="card-header">
            <div class="header-left">
              <img src="assets/images/webLink.png" alt="Course Icon" class="unit-icon" />
              <h4>Resources and Reference Links</h4>
            </div>
            <div class="block-actions">
            </div>
          </div>
          <h6>
            <i class="bi bi-journal-bookmark-fill"></i> Textbooks
          </h6>
          <ul class="objective-list" *ngIf="_syllabusData?.textbooks?.length; else noTextbooks">
            <li *ngFor="let book of _syllabusData.textbooks; let i = index">
              <strong>{{ book.title || "--" }} , </strong> {{ book.author || "--" }} , 
              <small>{{ book.publisher || "--" }}, {{ book.year || "--" }}</small>
            </li>
          </ul>
          <ng-template #noTextbooks>
            <p class="empty-note">No textbooks added yet.</p>
          </ng-template>
          <h6>
            <i class="bi bi-globe"></i> Weblinks
          </h6>
          <ul class="objective-list" *ngIf="_syllabusData?.web_references_links?.length; else noLinks">
            <li *ngFor="let web_link of _syllabusData.web_references_links">
              <a [href]="web_link" target="_blank" class="web_link">{{ web_link || "--" }}</a>
            </li>
          </ul>
          <ng-template #noLinks>
            <p class="empty-note">No web links added yet.</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>